module.exports = __webpack_public_path__ + "static/media/add.c29e81a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.svg
// module id = 8
// module chunks = 0